import dayjs from 'dayjs'

const getOffset = (date: Date = new Date()): number => {
  return -(date.getTimezoneOffset() / 60)
  // GMT + 3 gives -3
  // GMT -3 gives + 3
}

const getStartDateISOString = (date: Date = new Date()): string => {
  const offset = getOffset(date)
  return new Date(date.setHours(offset, 0, 0, 0)).toISOString()
}

const getEndDateISOString = (date: Date = new Date()): string => {
  const offset = getOffset(date)
  return new Date(date.setHours(23 + offset, 59, 59, 59)).toISOString()
}

const getOffsetDateISOString = (date: Date = new Date()): string => {
  const offset = getOffset()
  return dayjs(date).add(offset, 'hours').toISOString()
}

export {
  getOffset,
  getStartDateISOString,
  getEndDateISOString,
  getOffsetDateISOString,
}
